import { ResultadoExameEspecializadoInput, ResultadoExameEspecifico } from 'graphql/types.generated'
import { formatNumber, parseNumber } from 'util/number'

import {
  AllResultadoEspecificoValueType,
  ExameQueryModel,
  ResultadoExameEspecificoModel,
} from '../../model-resultadosExames'
import {
  getResultadoExameEspecificoFormatOnSave,
  getResultadoExameEspecificoProperties,
} from '../../util-resultadosExames'

export const convertResultadoExameMarcadoresBioquimicosToInput = (
  value: ResultadoExameEspecificoModel,
  flagPilotoCasaDecimal: boolean
): ResultadoExameEspecializadoInput => {
  const { resultado, exame } = value

  const { relatedDbEnum } = getResultadoExameEspecificoProperties(exame, flagPilotoCasaDecimal)

  return {
    procedimento: relatedDbEnum,
    valor: parseNumber(resultado),
  }
}

export const convertResultadoExamePrenatalToInput = (
  value: ResultadoExameEspecificoModel,
  flagPilotoCasaDecimal: boolean
): ResultadoExameEspecializadoInput => {
  const { resultado, exame } = value

  const { dpp, idadeGestacional } = resultado

  const { semanas, dias } = idadeGestacional || {}

  const { relatedDbEnum } = getResultadoExameEspecificoProperties(exame, flagPilotoCasaDecimal)

  return {
    procedimento: relatedDbEnum,
    dpp,
    igDias: dias,
    igSemanas: semanas,
  }
}

export const convertResultadoExamePuericulturaToInput = (
  value: ResultadoExameEspecificoModel,
  flagPilotoCasaDecimal: boolean
): ResultadoExameEspecializadoInput => {
  const { resultado, exame } = value

  const { relatedDbEnum } = getResultadoExameEspecificoProperties(exame, flagPilotoCasaDecimal)

  return {
    procedimento: relatedDbEnum,
    fichaComplementarPuericultura: resultado,
  }
}

export const convertResultadoExameQualitativoToInput = (
  value: ResultadoExameEspecificoModel,
  flagPilotoCasaDecimal: boolean
): ResultadoExameEspecializadoInput => {
  const { resultado, exame } = value

  const { relatedDbEnum } = getResultadoExameEspecificoProperties(exame, flagPilotoCasaDecimal)

  return {
    procedimento: relatedDbEnum,
    resultadoExameEstruturadoQualitativo: resultado,
  }
}

export const convertResultadoExameMarcadoresBioquimicosValueToModel = (
  input: ResultadoExameEspecifico,
  exame: ExameQueryModel,
  flagPilotoCasaDecimal: boolean
): AllResultadoEspecificoValueType => {
  const { precision = 0 } = getResultadoExameEspecificoProperties(exame, flagPilotoCasaDecimal)

  // @diegoasmello fix cast https://github.com/laboratoriobridge/pec/issues/11424
  const value = formatNumber(input.valor, precision) as AllResultadoEspecificoValueType

  const formatOnLoad = getResultadoExameEspecificoFormatOnSave(exame, flagPilotoCasaDecimal)

  if (formatOnLoad) {
    const { resultado } = formatOnLoad({ resultado: value }, exame)
    return resultado
  }

  return value
}

export const convertResultadoExamePrenatalValueToModel = (
  input: ResultadoExameEspecifico
): AllResultadoEspecificoValueType => {
  const { dpp, igDias, igSemanas } = input

  // @diegoasmello fix cast https://github.com/laboratoriobridge/pec/issues/11424
  return {
    dpp,
    idadeGestacional: {
      dias: igDias,
      semanas: igSemanas,
    },
  } as AllResultadoEspecificoValueType
}

export const convertResultadoExamePuericulturaValueToModel = (
  input: ResultadoExameEspecifico
): AllResultadoEspecificoValueType => {
  const { resultadoExamePuericulturaEnum } = input

  // @diegoasmello fix cast https://github.com/laboratoriobridge/pec/issues/11424
  return resultadoExamePuericulturaEnum as AllResultadoEspecificoValueType
}

export const convertResultadoExameQualitativoValueToModel = (
  input: ResultadoExameEspecifico
): AllResultadoEspecificoValueType => {
  const { resultadoExameEstruturadoQualitativoEnum } = input

  return resultadoExameEstruturadoQualitativoEnum as AllResultadoEspecificoValueType
}
